module.exports = __webpack_public_path__ + "media/barometer/report-cover-6f92083a.jpg";